import {memoize} from '@servicenow/ui-internal';

function containsNonAsciiChars(str = '') {
	return typeof str !== 'string' ? false : [...str].some(char => char.charCodeAt(0) > 127);
}

const memoizedContainsNonAsciiChars = memoize(containsNonAsciiChars, {
	profileName: 'containsNonAsciiChars'
});

/**
 * Removes headers with non ascii values
 * @private
 * @param headers
 */
export default function filterHeaders(headers) {
	const nonAsciiHeader = {};
	for (const key in headers) {
		if (!memoizedContainsNonAsciiChars(headers[key])) nonAsciiHeader[key] = headers[key];
	}

	return nonAsciiHeader;
}
